import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/pro-regular-svg-icons';

interface DevelopmentManagerTypeOptionProps {
    title: string;
    subtitle: string;
}

const DevelopmentManagerTypeOption: React.FC<DevelopmentManagerTypeOptionProps> = ({
    title,
    subtitle,
}) => (
    <div className="d-flex justify-content-between align-items-center">
        <div>
            <div className="text-dark">{title}</div>
            <div>{subtitle}</div>
        </div>
        <FontAwesomeIcon icon={faAngleRight} className="text-dark" />
    </div>
);

export default DevelopmentManagerTypeOption;
